export default __webpack_public_path__ + "static/media/BevCrair.bf86d3e3.jpg";